export default __webpack_public_path__ + "fa528547c8f8161e8a4e70aec49dba7b.svg";